export enum SpecialCourse {
  DirectEntry = 'Direct Entry',
  IntegratedMasters = 'Integrated Masters',
  InternationalDirect = 'International Direct',
  MastersInternationalDirect = 'Masters International Direct',
  UndergraduateTransferProgram = 'Undergraduate Transfer Program',
  InternationalDirectTransfer = 'International Direct Transfer',
}
